import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import Modal from "@mui/material/Modal";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DataGrid } from "@mui/x-data-grid";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import categoriesData from "../json/categories.json";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  p: 4,
};

const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: "left",
}));

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
}));

export default function Products() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [dense, setDense] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const [prod, setProd] = useState({
    prod_name: "",
    prod_price: "",
    prod_sale: 0,
    prod_stock: 0,
    prod_features: "",
    prod_desc: "",
    prod_expiry: "",
    prod_var: "",
    prod_category: "",
    prod_collection: "",
    prod_popular: "",
    prod_preorder: "",
    prod_limited: "",
    prod_img: "",
  });

  // Grid Data

  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "prod_name",
      headerName: "Name",
      editable: true,
    },
    {
      field: "prod_price",
      headerName: "Features",
      editable: true,
    },
    {
      field: "prod_sale",
      headerName: "Sale Price",
      editable: true,
    },
    {
      field: "prod_stock",
      headerName: "Stock",
      editable: true,
    },

    {
      field: "prod_features",
      headerName: "Product Features",
      editable: true,
    },
    {
      field: "prod_desc",
      headerName: "Description",
      editable: true,
    },
    {
      field: "prod_expiry",
      headerName: "Expiry",
      // type: 'number',
      editable: true,
    },
    {
      field: "prod_var",
      headerName: "Variation",
      editable: true,
    },
    {
      field: "prod_category",
      headerName: "Category",
      editable: true,
    },
    {
      field: "prod_collection",
      headerName: "Collection",
      editable: true,
    },
    {
      field: "prod_popular",
      headerName: "Popular",
      editable: true,
    },
    {
      field: "prod_img",
      headerName: "Image",
      editable: true,
    },

    // {
    //   field: 'prod_var',
    //   headerName: 'Product Variation',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    // },
  ];

  const rows = [
    {
      id: 1,
      prod_name: "Snow",
      prod_price: "Jon",
      prod_sale: 14,
      prod_stock: 0,
      prod_features: "",
      prod_desc: "",
      prod_expiry: "",
      prod_var: "",
      prod_category: "",
      prod_collection: "",
      prod_popular: "",
      prod_img: "",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send a POST request to the backend
    axios
      .post(
        `${baseURL}/addProduct`,
        {
          ...prod,
          prod_desc: prod.prod_desc.split("\n"),
          prod_features: prod.prod_features.split("\n"),
          prod_img: prod.prod_img.split("\n"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        alert("Product added succesfully!");

        setProd({
          prod_name: "",
          prod_price: "",
          prod_sale: 0,
          prod_stock: 0,
          prod_features: "",
          prod_desc: "",
          prod_expiry: "",
          prod_var: "",
          prod_category: "",
          prod_collection: "",
          prod_popular: "",
          prod_img: "",
        });
      })
      .catch((error) => {
        console.log(prod);
        // alert("Error adding product");
      });
  };

  return (
    <div className="AddProducts">
      <Stack direction="column">
        <DemoPaper variant="outlined">
          {" "}
          <Stack direction="column" spacing={0}>
            {" "}
            <Stack
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <Container>
                <h2>Orders</h2>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/">
                    MUI
                  </Link>
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/material-ui/getting-started/installation/"
                  >
                    Core
                  </Link>
                  <Link
                    underline="hover"
                    color="text.primary"
                    href="/material-ui/react-breadcrumbs/"
                    aria-current="page"
                  >
                    Breadcrumbs
                  </Link>
                </Breadcrumbs>
              </Container>{" "}
              <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs="auto">
                  <Button></Button>
                </Grid>
                <Grid item xs="auto">
                  <Button onClick={handleOpen} variant="contained">
                    Add Product
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Stack>
        </DemoPaper>
      </Stack>

      <Grid container sx={{ width: "100%" }}>
        <Box
          sx={{
            height: "450px",
            width: "calc(100% )",
            backgroundColor: "#fff",
          }}
        >
          {" "}
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </Grid>

      <div>
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            <Typography variant="h6" gutterBottom>
              New Product
            </Typography>

            <Stack direction="column" spacing={2}>
              {" "}
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Product Name"
                  value={prod.prod_name}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_name: event.target.value,
                    }));
                  }}
                  fullWidth
                />
                <TextField
                  required
                  id="outlined-number"
                  label="Stock"
                  type="number"
                  value={prod.prod_stock}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_stock: event.target.value,
                    }));
                  }}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                  fullWidth
                />{" "}
              </Stack>
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Images"
                  value={prod.prod_img}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_img: event.target.value,
                    }));
                  }}
                  fullWidth
                  multiline
                />
              </Stack>
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Product Features"
                  value={prod.prod_features}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_features: event.target.value,
                    }));
                  }}
                  fullWidth
                  multiline
                />
              </Stack>
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Product Description"
                  value={prod.prod_desc}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_desc: event.target.value,
                    }));
                  }}
                  fullWidth
                  multiline
                />
              </Stack>
              <Stack direction="column" sx={{ width: "100%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker label="Product Expiry" />
                </LocalizationProvider>
              </Stack>
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <TextField
                  required
                  id="outlined-number"
                  label="Price"
                  type="number"
                  value={prod.prod_price}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_price: event.target.value,
                    }));
                  }}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                  fullWidth
                />{" "}
                <TextField
                  required
                  id="outlined-number"
                  label="Sale"
                  type="number"
                  value={prod.prod_sale}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_sale: event.target.value,
                    }));
                  }}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                  fullWidth
                />{" "}
              </Stack>
              <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Brand"
                  value={prod.prod_var}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_var: event.target.value,
                    }));
                  }}
                  fullWidth
                />{" "}
                <FormControl fullWidth>
                  {" "}
                  <TextField
                    select
                    label="Category"
                    id="outlined-required"
                    value={prod.prod_category}
                    defaultValue="Film"
                    onChange={(event) => {
                      setProd((prevUser) => ({
                        ...prevUser,
                        prod_category: event.target.value,
                      }));
                    }}
                    fullWidth
                  >
                    {categoriesData.categories.map((category) => (
                      <MenuItem key={category} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                {/* <FormControl fullWidth>
                  {" "}
                  <InputLabel id="demo-simple-select-label">Age</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={prod.prod_collection}
                    onChange={(event) => {
                      setProd((prevUser) => ({
                        ...prevUser,
                        prod_collection: event.target.value,
                      }));
                    }}
                    label="Collection"
                    onChange={handleChange}
                    fullWidth
                  >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </FormControl> */}
              </Stack>
              <Stack direction="row" justifyContent={"space-between"}>
                {" "}
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  value={prod.prod_preorder}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_preorder: event.target.value,
                    }));
                  }}
                  label="Pre-order"
                />{" "}
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  value={prod.prod_popular}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_popular: event.target.value,
                    }));
                  }}
                  label="Popular"
                />{" "}
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  value={prod.prod_limited}
                  onChange={(event) => {
                    setProd((prevUser) => ({
                      ...prevUser,
                      prod_limited: event.target.value,
                    }));
                  }}
                  label="Limited"
                />
              </Stack>
            </Stack>

            <Stack direction="column" sx={{ width: "100%" }}>
              <Button>Save as Draft</Button>

              <Button onClick={handleSubmit} variant="contained">
                Add Product
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
